import { ref } from 'vue'

const isEmbedded = ref(false)

export function useSignalEmbedded() {
    function enableEmbedMode() {
        isEmbedded.value = true

        console.info('Embed Mode Initialized')
    }

    return {
        isEmbedded,
        enableEmbedMode,
    }
}
